import api from "@/services/api";

import {
  SET_PERSONAL_INFO,
  SET_PERSONAL_SINGLES,
  SET_PERSONAL_ALBUMS,
  SET_ARTISTS,
  SET_ALBUMS
} from "@/store/mutation-types";

export default {
  async info({ commit }, { params }) {
    const { payload = {} } = await api.personal.fetch("info", params);
    const { artist } = payload;

    commit(SET_PERSONAL_INFO, artist);
    commit(`artists/${SET_ARTISTS}`, [artist], { root: true });

    return payload;
  },
  async singles({ commit }, { params }) {
    const { payload = {} } = await api.personal.fetch("singles", params);
    const { singles = [] } = payload;

    commit(SET_PERSONAL_SINGLES, singles);
    commit(`albums/${SET_ALBUMS}`, singles, { root: true });

    return payload;
  },
  async albums({ commit }, { params }) {
    const { payload = {} } = await api.personal.fetch("albums", params);
    const { albums = [] } = payload;

    commit(SET_PERSONAL_ALBUMS, albums);
    commit(`albums/${SET_ALBUMS}`, albums, { root: true });

    return payload;
  },
  async update({ commit }, params) {
    const { payload = {} } = await api.personal.update(params);
    const { artist } = payload;

    commit(SET_PERSONAL_INFO, artist);
    commit(`artists/${SET_ARTISTS}`, [artist], { root: true });

    return artist;
  },
  async updateCover({ commit }, params) {
    const { payload = {} } = await api.personal.cover(params);
    const { artist } = payload;

    commit(SET_PERSONAL_INFO, artist);
    commit(`artists/${SET_ARTISTS}`, [artist], { root: true });

    return artist;
  },
  async updateGenres({ commit }, params) {
    const { payload = {} } = await api.personal.genres(params);
    const { artist } = payload;

    commit(SET_PERSONAL_INFO, artist);
    commit(`artists/${SET_ARTISTS}`, [artist], { root: true });

    return artist;
  },
  async save({ commit }, params) {
    try {
      const { payload = {} } = await api.personal.save(params);
      const { artist } = payload;

      await this.$app.$router.push("/profile");

      commit(SET_PERSONAL_INFO, artist);
      commit(`artists/${SET_ARTISTS}`, [artist], { root: true });

      return artist;
    } catch (error) {
      console.error(error);
    }
  }
};
